import basicRest from '../common/CommonRestFunctions'

const baseAnalysisUrl = '/analysis'

export default {
  getAnalysis (id) {
    return basicRest.executeBasicAxiosGet(baseAnalysisUrl + `/${id}`)
  },
  saveAnalysis (analysisInfo) {
    return basicRest.executeBasicAxiosPost(baseAnalysisUrl + `/save/${analysisInfo.incomeId}`, analysisInfo)
  }
}
